import api from './api'

class DemoService {
    getStatistics(chart) {
        return api.get(`/demo/${chart}`)
    }
}

export default new DemoService()